<template>
  <div class="totalPie">
    <div class="tit">
      <p>事件降雨情况</p>
    </div>
    <div class="content">{{itemData.ydbJyqkms}}</div>
    <div class="tit">
      <p>淤地坝水毁情况</p>
    </div>
    <div class="content">{{itemData.ydbShqkms}}</div>
    <div class="tit">
      <p>淤地坝水毁原因</p>
    </div>
    <div class="content">{{itemData.ydbShyy}}</div>
  </div>
</template>

<script>
  import {} from "@/api/api.js";
  export default {
    props: ['itemData'],
    data() {
      return {};
    },
    mounted() {},
    computed: {},
    watch: {},
    methods: {},
  };
</script>

<style scoped>
  .totalPie {
    width: 100%;
    height: 800px;
    background: url(../../common/images/dbg.png) no-repeat center;
    background-size: 100% 100%;
  }
  .content {
    width: 90%;
    height: 28%;
    color: #fff;
    font-size: 16px;
    margin-left: 5%;
    line-height: 2;
    text-indent: 2em;
  }
</style>
